import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import assets from "../assets/imgs";
import config from "../config/config";
import AgreementPage from "../components/AgreementPage";
const API_URL = config.API_URL;


function Join() {
  const [orgNum, setOrgNum] = useState("");
  const [email, setEmail] = useState("");
  const [emailCodeSend, setEmailCodeSend] = useState(false);
  const [emailCode, setEmailCode] = useState(0);
  const [emailCheck, setEmailCheck] = useState(false);
  const [account, setAccount] = useState("");
  const [accountCheck, setAccountCheck] = useState(false);
  const [orgNumCheck, setOrgNumCheck] = useState(false);
  const [startupList, setStartUpList] = useState([]);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [startup, setStartup] = useState("");
  const [search, setSearch] = useState('');
  const [showOptions, setShowOptions] = useState(false);

  const filteredStartupList = startupList.filter(item =>
    item.name.toLowerCase().includes(search.toLowerCase()) && item.name !== 'test'
  );

  const [name , setName] = useState("");
  const [role, setRole] = useState("");
  const [sex, setSex] = useState("");
  const [phone, setPhone] = useState("");
  const [agreement, setAgreement] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [isAgreementOpen, setIsAgreementOpen] = useState(false);
  const openAgreement = () => setIsAgreementOpen(true);
  const closeAgreement = () => setIsAgreementOpen(false);
  const closeAgreementWithAgree = () =>{
    setIsAgreementOpen(false);
    setAgreement(true);
  }

  const checkAccountIdentity = async (e) =>{
    e.preventDefault();
    const isAccountTyped = (account.length > 0);
    if(!isAccountTyped){
      setError("계정을 입력해 주세요.");
      return;
    }
    try{
      const response = await fetch(`${API_URL}/api/auth/checkAccountIdentity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          account: account,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        // console.log(data.result); // 로그인 성공 메시지
        if(!data.result){
          setAccountCheck(true);
          alert("사용 가능한 계정입니다.");
        }else{
          setAccountCheck(false);
          alert("이미 사용 중인 계정입니다.");
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message);
      }
    }catch(error){
      console.error("Error:", error);
      setError("오류가 발생했습니다. 콘솔을 확인하세요.");
    }
  }
  const checkOrgNum = async (e) =>{
    e.preventDefault();
    // console.log(orgNum, orgNum > 1000);
    const isOrgNumValid = (orgNum > 1000);
    if(!isOrgNumValid){
      alert("유효한 기관코드를 입력하세요.");
      return;
    }
    try{
      const response = await fetch(`${API_URL}/api/auth/checkIncubatorCodeAndGetStartups`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          incubatorCode: orgNum,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        if(data.result){
          setOrgNumCheck(true);
          setStartUpList(data.value);
          alert("유효한 기관 코드 입니다.");
        }else{
          setAccountCheck(false);
          alert("유효한 기관코드를 입력하세요.");
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message);
      }
    }catch(error){
      console.error("Error:", error);
      setError("오류가 발생했습니다. ");
    }
  }
  const checkEmail = async (e) =>{
    e.preventDefault();
    // console.log(orgNum, orgNum > 1000);
    const isEmailValid = email === "admin" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isEmailValid) {
      alert("유효한 이메일을 입력하세요.");
      return;
    }
    try{
      const response = await fetch(`${API_URL}/api/auth/sendVerifCode`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        if(data.result){
          setEmailCodeSend(true);
          alert(data.message);
        }else{
          setEmailCodeSend(false);
          alert('오류가 발생했습니다.: ', data.message);
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message);
      }
    }catch(error){
      console.error("Error:", error);
      setError("오류가 발생했습니다. ");
    }
  }
  const checkEmailCode = async (e) =>{
    e.preventDefault();
    // console.log(orgNum, orgNum > 1000);
    if (emailCode.length !== 6) {
      alert("인증번호는 6자리 입니다.");
      return;
    }
    try{
      const response = await fetch(`${API_URL}/api/auth/checkVerifCode`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          verifCode: emailCode,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        if(data.result){
          setEmailCheck(true);
          alert("이메일 인증이 완료되었습니다.");
        }else{
          setEmailCheck(false);
          alert("오류가 발생했습니다.: ", data.message);
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message);
      }
    }catch(error){
      console.error("Error:", error);
      setError("오류가 발생했습니다. ");
    }
  }
  const handleJoin = async (e) => {
    e.preventDefault();
    console.log('로그인 입력됨');

    const isOrgNumValid = (orgNum > 1000);
    if(!orgNumCheck){
      alert("기관 코드를 체크 해주세요");
      return;
    }
    if(!accountCheck){
      alert("아이디 중복 확인을 수행해 주세요");
      return;
    }
    const isPasswordSame = ((password.length >= 6) && (password === passwordConfirm));
    if(!isPasswordSame){
      if(password.length < 6){
        alert('6자리 이상의 비밀번호를 설정해 주세요.');
        return;
      }
      alert("비밀번호가 다릅니다.");
      return;
    }
    const isNameValid = (name !== "");
    if(!isNameValid){
      alert("성함을 입력해주세요");
      return;
    }
    // console.log('startup 포함하나', startup, startupList.includes(startup));
    const isStartupValid = (startup !== "");
    if(!isStartupValid){
      alert("올바른 기업명을 선택해 주세요.");
      return;
    }
    const isRoleValid = (role !== "");
    if(!isRoleValid){
      alert("직급을 입력해주세요");
      return;
    }    
    const isPhoneValid = /^010-\d{4}-\d{4}$/.test(phone);
    if(!isPhoneValid){
      alert("유효한 전화번호를 입력해주세요");
      return;
    }
    // 이메일 형식 검증
    const isEmailValid = email === "admin" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isEmailValid) {
      alert("유효한 이메일을 입력하세요.");
      return;
    }
    if(!emailCheck){
      alert('이메일 인증을 받아주세요');
      return;
    }
    const isSexValid = (sex !== "");
    if(!isSexValid){
      alert("성별을 골라주세요");
      return;
    }
    if(!agreement){
      alert("약관 동의를 해주세요");
      return;
    }

    try {
      // OpenSearch에서 사용자 문서 조회
      const response = await fetch(`${API_URL}/api/auth/join`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          incubatorCode: orgNum,
          account: account,
          pw: password,
          name: name,
          startup: startup,
          role: role,
          phone: phone,
          email: email,
          sex: sex,
        }),
      });
  
      if (response.ok) {
        const data = await response.json();
        console.log(data.message); // 로그인 성공 메시지
        alert("회원가입이 완료 되었습니다.");
        navigate("/");
      } else {
        const errorData = await response.json();
        alert(errorData.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("오류가 발생했습니다. 콘솔을 확인하세요.");
    }
  };

  const formatPhoneNumber = (value) =>{
    const numbersOnly = value.replace(/\D/g, "");

    if (numbersOnly.length < 4) {
      return numbersOnly;
    } else if (numbersOnly.length < 8) {
      return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`;
    } else {
      return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3, 7)}-${numbersOnly.slice(7, 11)}`;
    }
  }

  const handlePhoneChange = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };

  return (
    <div style={styles.divBody}>
      <div style={styles.loginRight}>
        <form style={styles.divLoginColumn} onSubmit={handleJoin}>
          <div style={styles.divLoginColumnBody}>
            {/* 오류 메시지 표시 */}
            {error && (
              <p style={{ color: "red", fontSize: "14px", marginBottom: "16px" }}>
                {error}
              </p>
            )}

            <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>기관코드</h3>
              <div style={styles.rowAccount}>
                <input
                  style={{
                    ...styles.inputLoginInput,
                    backgroundColor: orgNumCheck ? "#f0f0f0" : "white", 
                    cursor: orgNumCheck ? "not-allowed" : "text"          
                  }}
                  onChange={(e) => setOrgNum(e.target.value)}
                  placeholder="기관코드를 입력해주세요."
                  disabled={orgNumCheck}
                />
                <button className="font-body2-semibold" 
                  style={{...styles.btnAccountCheck,
                    width: "140px",
                    backgroundColor: orgNumCheck ? "var(--grayscale_30)" : "var(--grayscale_60)", 
                    cursor: orgNumCheck ? "not-allowed" : "pointer"          
                  }} onClick={checkOrgNum}
                  disabled={orgNumCheck}>
                  기관 코드 확인
                </button>
              </div>
            </div>
            <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>아이디</h3>
              <div style={styles.rowAccount}>
                <input
                   style={{
                    ...styles.inputLoginInput,
                    backgroundColor: accountCheck ? "#f0f0f0" : "white", 
                    cursor: accountCheck ? "not-allowed" : "text"          
                  }}
                  onChange={(e) => setAccount(e.target.value)}
                  placeholder="아이디를 입력해주세요."
                  disabled={accountCheck}
                />
                <button className="font-body2-semibold" 
                  style={{...styles.btnAccountCheck,
                    backgroundColor: accountCheck ? "var(--grayscale_30)" : "var(--grayscale_60)", 
                    cursor: accountCheck ? "not-allowed" : "pointer"          
                  }} onClick={checkAccountIdentity}
                  disabled={accountCheck}>
                  중복 확인
                </button>
              </div>
            </div>
            <div style={styles.rowDouble}>
              <div style={styles.divDoubleInput}>
                <h3 style={styles.loginLabel}>비밀번호</h3>
                <input
                  style={styles.inputLoginInput}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="비밀번호를 입력해주세요."
                />
              </div>
              <div style={styles.divDoubleInput}>
                <h3 style={styles.loginLabel}>비밀번호 확인</h3>
                <input
                  style={styles.inputLoginInput}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  type="password"
                  placeholder="비밀번호를 한번 더 입력해주세요."
                />
              </div>
            </div>            

            <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>기업명</h3>
              <div style={{ position: 'relative', width: "100%"}}>
                <input
                  style={{ ...styles.inputLoginInput, backgroundColor: '#fff' }}
                  type="text"
                  placeholder="기업명을 입력해주세요"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setShowOptions(true);
                  }}
                  onFocus={() => setShowOptions(true)}
                  onBlur={() => setTimeout(() => setShowOptions(false), 150)} // blur 시 살짝 딜레이
                />
                {showOptions && (
                  <ul style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    maxHeight: '200px',
                    overflowY: 'auto',
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    zIndex: 1000,
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                  }}>
                    {filteredStartupList.length > 0 ? (
                      filteredStartupList.map((item, index) => (
                        <li
                          key={index}
                          style={{ padding: '8px', cursor: 'pointer' }}
                          onMouseDown={() => {
                            setStartup(item.name);
                            setSearch(item.name);
                            setShowOptions(false);
                          }}
                        >
                          {item.name}
                        </li>
                      ))
                    ) : (
                      <li style={{ padding: '8px' }}>해당하는 기업이 없습니다.</li>
                    )}
                  </ul>
                )}
              </div>
            </div>


            <div style={styles.rowDouble}>
              <div style={styles.divDoubleInput}>
                <h3 style={styles.loginLabel}>성함</h3>
                <input
                  style={styles.inputLoginInput}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="성함을 입력해주세요."
                />
              </div>
              <div style={styles.divDoubleInput}>
                <h3 style={styles.loginLabel}>직급</h3>
                <input
                  style={styles.inputLoginInput}
                  onChange={(e) => setRole(e.target.value)}
                  placeholder="직급을 입력해주세요."
                />
              </div>
            </div>            
            <div style={styles.rowDouble}>
              <div style={styles.divDoubleInput}>
                <h3 style={styles.loginLabel}>전화번호</h3>
                <input
                  style={styles.inputLoginInput}
                  onChange={handlePhoneChange}
                  value={phone}
                  maxLength={13}
                  placeholder="연락처를 입력해주세요.(숫자만)"
                />
              </div>
              <div style={styles.divDoubleInput}>
                <h3 style={styles.loginLabel}>성별</h3>
                <select
                  style={{ 
                    ...styles.inputLoginInput, 
                    backgroundColor: "#fff", 
                    cursor: "pointer" 
                  }}
                  value={sex}
                  onChange={(e) => setSex(e.target.value)}
                >
                  <option value="" disabled>성별을 골라주세요</option>
                  <option value="male">남성</option>
                  <option value="female">여성</option>
                </select>
              </div>
            </div>            
            <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>이메일</h3>
              <div style={styles.rowAccount}>
                <input
                   style={{
                    ...styles.inputLoginInput,
                    backgroundColor: emailCodeSend ? "#f0f0f0" : "white", 
                    cursor: emailCodeSend ? "not-allowed" : "text"          
                  }}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="이메일을 입력해주세요."
                  disabled={emailCodeSend}
                />
                <button className="font-body2-semibold" 
                  style={{...styles.btnAccountCheck,
                    backgroundColor: emailCodeSend ? "var(--grayscale_30)" : "var(--grayscale_60)", 
                    cursor: emailCodeSend ? "not-allowed" : "pointer"          
                  }} onClick={checkEmail}
                  disabled={emailCodeSend}>
                  이메일 인증
                </button>
              </div>
              {/* <h3 style={styles.loginLabel}>이메일</h3>
              <input
                style={styles.inputLoginInput}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="이메일을 입력해주세요."
              /> */}
            </div>
            {emailCodeSend && (
              <div style={styles.divLoginInput}>
                <h3 style={styles.loginLabel}>이메일 인증 코드</h3>
                <div style={styles.rowAccount}>
                  <input
                    style={{
                      ...styles.inputLoginInput,
                      backgroundColor: emailCheck ? "#f0f0f0" : "white", 
                      cursor: emailCheck ? "not-allowed" : "text"          
                    }}
                    onChange={(e) => setEmailCode(e.target.value)}
                    placeholder="인증코드를 입력해주세요."
                    disabled={emailCheck}
                  />
                  <button className="font-body2-semibold" 
                    style={{...styles.btnAccountCheck,
                      backgroundColor: emailCheck ? "var(--grayscale_30)" : "var(--grayscale_60)", 
                      cursor: emailCheck ? "not-allowed" : "pointer"          
                    }} onClick={checkEmailCode}
                    disabled={emailCheck}>
                    인증 하기
                  </button>
                </div>
              </div>
            )}
            <div style={{...styles.divLoginInput, gap:"12px", padding:"14px 19px", backgroundColor: "var(--grayscale_20)"}}>
              <h3 className="font-body4-semibold" style={{color: "var(--grayscale_90)"}}>
                약관 동의를 확인하셨나요?</h3>
              <div style={styles.rowAgree}>
                <div style={styles.rowCheckBox} onClick={() => {
                    if(agreement){setAgreement(false);}
                    else{alert("약관 자세히 보기를 클릭해주세요");}
                    }}>
                  <input type="checkbox" style={styles.checkBox} checked={agreement}
                    readOnly/>
                  <p className="font-body3-medium" style={{color: "var(--grayscale_80)"}}>
                    네 확인했습니다.</p>
                </div>
                <p className="font-body3-medium" style={{color:"var(--grayscale_60)", cursor: "pointer"}}
                  onClick={openAgreement}>
                  [약관 자세히 보기]</p>
              </div>
            </div>
            <button type="submit" style={styles.btnLogin}>
              확인
            </button>
          </div>
        </form>
      </div>

      {isAgreementOpen && <AgreementPage onClose={closeAgreement} onAgree={closeAgreementWithAgree}/>}
    </div>
  );
}

const input ={
  boxSizing : "border-box"
}

const styles = {
  divBody: {
    display: "flex", width: "1440px",
    height: "100vh", justifyContent: "center"
  },
  imgs: {
    width: "50%",
    height: "auto",
  },
  loginRight: {
    backgroundColor: "white",
    width: "50%",
    height: "100%",
    borderRadius: "0px 24px 24px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 4px 12.6px 0px rgba(90, 87, 93, 0.14)",
  },
  divLoginColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "44px",
    width: "100%",
    margin: "40px 70px 80px 70px"
  },
  divLoginColumnBody: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  divLoginInput: {
    ...input,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    alignItems: "flex-start",
    justifyContent: "center",
    alignSelf: "stretch",
    overflow: "visible",
  },
  divDoubleInput: {
    ...input,
    boxSizing: "border-box",
    display: "flex",
    flex:"1",
    flexDirection: "column",
    gap: "6px",
    alignItems: "flex-start",
    justifyContent: "center",
    alignSelf: "stretch",
    overflow: "hidden",
  },
  rowAccount:{
    display: "flex",
    gap: "16px",
    width: "100%"
  },
  btnAccountCheck:{
    width: "104px",
    backgroundColor: "var(--grayscale_60)",
    borderRadius: "8px",
    color: "white",
    flexShrink: 0,
  },
  rowDouble:{
    display:"flex",
    width: "100%",
    gap:"16px",
    justifyContent: "space-between",
  },
  loginLabel: {
    color: "#232323",
    fontFamily: "Pretendard-SemiBold, sans-serif",
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: 600,
  },
  inputLoginInput: {
    ...input,
    background: "#ffffff",
    borderRadius: "8px",
    borderStyle: "solid",
    borderColor: "#dddde2",
    borderWidth: "1px",
    padding: "12px 16px 12px 12px",
    width: "100%",
  },
  btnLogin: {
    background: "#686769",
    borderRadius: "8px",
    padding: "12px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "stretch",
    color: "white",
    fontFamily: "Pretendard-SemiBold, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    cursor: "pointer",
  },
  divLoginColumnFoot: {
    display: "flex",
    gap: "24px",
  },
  divLoginColumnFootP: {
    color: "#515052",
    fontFamily: "Pretendard",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "21px",
  },
  rowAgree:{
    display:"flex",
    width:"100%", justifyContent: "space-between"
  },
  rowCheckBox:{
    display:"flex", gap:"12px", cursor:"pointer"
  },
  checkBox:{
    margin: "0", width:"20px", 
  },


  container: { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" },
  form: { backgroundColor: "#fff", padding: "2rem", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
  inputGroup: { marginBottom: "1rem" },
  button: { padding: "0.5rem", backgroundColor: "#4CAF50", color: "white", border: "none", cursor: "pointer" },
};

export default Join;